var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/components/one-key-onboarding/one-key-onboarding-wrapper.tsx
import React59, { useEffect as useEffect6 } from "react";
import { useExperiment } from "@shared-ui/experiment-context";

// src/utils/utils.ts
var HOMEPAGE_PATH = "/";
var getPath = uiLinkAction => {
  const {
    resource,
    useRelativePath
  } = uiLinkAction;
  switch (resource.__typename) {
    case "HttpURI":
      return useRelativePath ? resource.relativePath : resource.value;
    default:
      return resource.value;
  }
};
var getUniversalOnboardingActionType = onboardingButtonAction => {
  if ((onboardingButtonAction == null ? void 0 : onboardingButtonAction.__typename) === "OneKeyUniversalOnboardingOperationAction") {
    return onboardingButtonAction.actionType;
  }
  return "";
};
var navigateToErrorPage = () => {
  window.location.href = `/onboarding/error?origin=${encodeURIComponent(window.location.href)}`;
};
var navigateToLink = operationResult => {
  window.location.href = `${getPath(operationResult)}`;
};
var getDecodedUrl = url => {
  try {
    const decodedUrl = decodeURIComponent(url);
    return decodedUrl !== url ? getDecodedUrl(decodedUrl) : decodedUrl;
  } catch (_) {
    return url;
  }
};
var encodeUrl = url => {
  const [path, queryString] = url.split("?");
  const encodedPath = encodeURIComponent(path);
  let encodedQueryString = "";
  if (queryString) {
    encodedQueryString = queryString.split("&").map(param => {
      const [key, value] = param.split("=");
      const decodedValue = getDecodedUrl(value);
      return `${key}=${encodeURIComponent(decodedValue)}`;
    }).join("&");
  }
  const encodedPathWithQueryParam = encodedQueryString ? `${encodedPath}?${encodedQueryString}` : encodedPath;
  const replaceDecodedSlash = encodedPathWithQueryParam.replace(/%2F/g, "/");
  return replaceDecodedSlash;
};
var encodeAbsoluteUrl = url => {
  const relativePathWithQueryParams = url.pathname + url.search;
  return encodeUrl(relativePathWithQueryParams);
};
var isRelativePath = path => {
  return /^\/[^/].*/.test(path);
};
var toRelativeURL = input => {
  try {
    const url = new URL(input);
    return encodeAbsoluteUrl(url);
  } catch (error) {
    if (isRelativePath(input)) {
      return encodeUrl(input);
    }
    return "/";
  }
};
var navigateToRelativeUrlOrFallbackUrl = url => {
  const redirectUrl = url ? toRelativeURL(url) : HOMEPAGE_PATH;
  window.location.assign(redirectUrl);
};

// src/components/one-key-onboarding/one-key-universal-onboarding/one-key-universal-onboarding.tsx
import React58, { useEffect as useEffect5, useState as useState4 } from "react";
import { gql as gql33, useQuery } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";

// src/utils/logger/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var UNIVERSAL_ONBOARDING_LOGGER_EVENTS = {
  ONE_KEY_UNIVERSAL_ONBOARDING_QUERY_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_QUERY_ERROR"),
  ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_ERROR"),
  ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_FAILURE"),
  ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_SUCCESS: new SystemEvent(SystemEventLevel.INFO, "ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_SUCCESS"),
  ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_ERROR"),
  ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_FAILURE"),
  ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_SUCCESS: new SystemEvent(SystemEventLevel.INFO, "ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_SUCCESS")
};

// src/utils/logger/utils.ts
var stringifyEventPayload = payload => {
  return JSON.stringify(payload);
};

// src/components/one-key-onboarding/onboarding-screen.tsx
import React57 from "react";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/welcome-screen.tsx
import React29, { useCallback as useCallback6, useEffect as useEffect3 } from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2, MinMax } from "@egds/react-core/layout-grid";
import { EGDSSheet, EGDSSheetContent } from "@egds/react-core/sheet";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { ViewExtraLarge as ViewExtraLarge3, Viewport as Viewport14 } from "@shared-ui/viewport-context";

// src/hooks/use-onboarding-utils.ts
import { useCallback as useCallback3 } from "react";

// src/components/one-key-onboarding/providers/onboarding-dialog-provider.tsx
import React, { createContext, useCallback, useContext, useMemo } from "react";
import { useDialog } from "@shared-ui/dialog-context";
var OnboardingDialogContext = createContext({
  isDialogOpen: false,
  openDialog: () => void 0,
  closeDialog: () => void 0,
  DialogComponent: () => null
});
var OnboardingDialogContextProvider = ({
  mockedContext,
  children
}) => {
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog("one-key-onboarding-dialog", void 0, false);
  const openDialog = useCallback(() => {
    dialogActions.openDialog();
  }, [dialogActions]);
  const closeDialog = useCallback(() => {
    dialogActions.closeDialog();
  }, [dialogActions]);
  const context = useMemo(() => ({
    isDialogOpen,
    openDialog,
    closeDialog,
    DialogComponent
  }), [isDialogOpen, openDialog, closeDialog, DialogComponent]);
  return /* @__PURE__ */React.createElement(OnboardingDialogContext.Provider, {
    value: mockedContext || context
  }, children);
};
var useOnboardingDialogContext = () => useContext(OnboardingDialogContext);

// src/components/one-key-onboarding/providers/onboarding-screens-provider.tsx
import React2, { createContext as createContext2, useCallback as useCallback2, useContext as useContext2, useMemo as useMemo2, useState } from "react";
var OnboardingScreensContext = createContext2({
  currentScreen: null,
  getIsLastScreen: () => false,
  navigateToNextScreen: () => void 0,
  setScreens: () => void 0
});
var OnboardingScreensProvider = ({
  mockedContext,
  children
}) => {
  const [onboardingScreensState, setOnboardingScreensState] = useState({
    screens: [],
    currentScreen: null,
    currentScreenIndex: 0
  });
  const getIsLastScreen = useCallback2(() => {
    return onboardingScreensState.currentScreenIndex === onboardingScreensState.screens.length - 1;
  }, [onboardingScreensState]);
  const navigateToNextScreen = useCallback2(() => {
    setOnboardingScreensState(prevState => {
      const nextScreenIndex = prevState.currentScreenIndex + 1;
      if (prevState.screens[nextScreenIndex]) {
        return __spreadProps(__spreadValues({}, prevState), {
          currentScreen: prevState.screens[nextScreenIndex].screen,
          currentScreenIndex: nextScreenIndex
        });
      }
      return prevState;
    });
  }, []);
  const setScreens = useCallback2(screens => {
    setOnboardingScreensState(prevState => __spreadProps(__spreadValues({}, prevState), {
      screens,
      currentScreen: screens[0] ? screens[0].screen : null,
      currentScreenIndex: 0
    }));
  }, []);
  const context = useMemo2(() => ({
    currentScreen: onboardingScreensState.currentScreen,
    getIsLastScreen,
    navigateToNextScreen,
    setScreens
  }), [onboardingScreensState, getIsLastScreen, navigateToNextScreen, setScreens]);
  return /* @__PURE__ */React2.createElement(OnboardingScreensContext.Provider, {
    value: mockedContext || context
  }, children);
};
var useOnboardingScreensContext = () => useContext2(OnboardingScreensContext);

// src/hooks/use-onboarding-utils.ts
var useOnboardingUtils = () => {
  const {
    closeDialog
  } = useOnboardingDialogContext();
  const {
    navigateToNextScreen,
    getIsLastScreen
  } = useOnboardingScreensContext();
  const proceedWithOnboardingFlow = useCallback3(() => {
    if (getIsLastScreen()) {
      closeDialog();
    } else {
      navigateToNextScreen();
    }
  }, [getIsLastScreen, navigateToNextScreen, closeDialog]);
  return {
    proceedWithOnboardingFlow
  };
};

// src/hooks/use-universal-onboarding-operation.ts
import { gql, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
var universalOnboardingOperation = gql`
  mutation OneKeyUniversalOnboardingMutation($context: ContextInput!, $onboardingOperation: String!) {
    oneKeyUniversalOnboardingOperation(context: $context, onboardingOperation: $onboardingOperation) {
      operationStatus
    }
  }
`;
var isOperationStatusSucceeded = result => {
  var _a, _b;
  return ((_b = (_a = result.data) == null ? void 0 : _a.oneKeyUniversalOnboardingOperation) == null ? void 0 : _b.operationStatus) === "SUCCEEDED" /* SUCCEEDED */;
};
var useUniversalOnboardingOperation = onboardingOperation => {
  const {
    context
  } = useBexApi();
  return useMutation(universalOnboardingOperation, {
    variables: {
      context,
      onboardingOperation
    }
  });
};

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/brand-assets.tsx
import React8 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var __EGDSIconFragment = gql2`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    theme
    title
    withBackground
  }
`;
var LoyaltyEGDSIcon = ({
  className,
  theme,
  isAriaHidden = false,
  data
}) => {
  var _a;
  const spotlight = (data == null ? void 0 : data.withBackground) ? "info" : void 0;
  return /* @__PURE__ */React3.createElement(EGDSIcon, {
    className,
    description: isAriaHidden ? void 0 : data == null ? void 0 : data.description,
    id: data == null ? void 0 : data.id,
    name: data !== null ? data.id : "",
    size: (data == null ? void 0 : data.size) ? EGDSIconSize[data.size] : void 0,
    title: isAriaHidden ? void 0 : (_a = data == null ? void 0 : data.title) != null ? _a : void 0,
    theme: theme || (data == null ? void 0 : data.theme) || void 0,
    spotlight
  });
};
LoyaltyEGDSIcon.displayName = "LoyaltyEGDSIcon";
LoyaltyEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-illustration.tsx
import React4 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
var __EGDSIllustrationFragment = gql3`
  fragment EGDSIllustrationFragment on Illustration {
    description
    id
    link: url
  }
`;
var EGDSIllustration = ({
  data
}) => /* @__PURE__ */React4.createElement(EGDSIllustrations, {
  alt: data.description,
  url: data.link
});
EGDSIllustration.displayName = "Illustration";
EGDSIllustration.fragment = __EGDSIllustrationFragment;

// ../internal/src/components/egds-graphic/egds-mark.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
var __EGDSMarkFragment = gql4`
  fragment EGDSMarkFragment on Mark {
    description
    id
    markSize: size
    url {
      ... on HttpURI {
        __typename
        relativePath
        value
      }
    }
  }
`;
var LoyaltyEGDSMark = ({
  className,
  markSize,
  data
}) => {
  var _a;
  return /* @__PURE__ */React5.createElement(EGDSMark, {
    className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: markSize || data.markSize && EGDSMarkSize[data.markSize],
    url: (_a = data.url) == null ? void 0 : _a.value
  });
};
LoyaltyEGDSMark.displayName = "LoyaltyEGDSMark";
LoyaltyEGDSMark.fragment = __EGDSMarkFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React6 from "react";
import { gql as gql5 } from "@apollo/client";
var __EGDSGraphicFragment = gql5`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }

    ... on Mark {
      ...EGDSMarkFragment
    }

    ... on Illustration {
      ...EGDSIllustrationFragment
    }
  }

  ${LoyaltyEGDSIcon.fragment}
  ${LoyaltyEGDSMark.fragment}
  ${EGDSIllustration.fragment}
`;
var EGDSGraphic = ({
  className,
  markSize,
  iconProps,
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React6.createElement(LoyaltyEGDSIcon, __spreadValues({
        className,
        data
      }, iconProps));
    case "Mark":
      return /* @__PURE__ */React6.createElement(LoyaltyEGDSMark, {
        className,
        data,
        markSize
      });
    case "Illustration":
      return /* @__PURE__ */React6.createElement(EGDSIllustration, {
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/title-image.tsx
import React7 from "react";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var TitleImage = ({
  data
}) => /* @__PURE__ */React7.createElement(Viewport, null, /* @__PURE__ */React7.createElement(ViewSmall, null, /* @__PURE__ */React7.createElement(EGDSGraphic, {
  data,
  markSize: 8
})), /* @__PURE__ */React7.createElement(ViewMedium, null, /* @__PURE__ */React7.createElement(EGDSGraphic, {
  data,
  markSize: 12
})));
TitleImage.displayName = "TitleImage";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/brand-assets.tsx
var fragment = gql6`
  fragment BrandAssetsFragment on OneKeyUniversalOnboardingBrandAssetCollection {
    titleImage {
      ...EGDSGraphicFragment
    }
    alternateTitleImage {
      ...EGDSGraphicFragment
    }
    brandLogos {
      ...EGDSGraphicFragment
    }
  }

  ${EGDSGraphic.fragment}
`;
var BrandAssets = ({
  data,
  isAlternateTitleImage
}) => {
  const {
    titleImage,
    alternateTitleImage,
    brandLogos
  } = data;
  return /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    space: "four"
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, isAlternateTitleImage ? /* @__PURE__ */React8.createElement(TitleImage, {
    data: alternateTitleImage
  }) : /* @__PURE__ */React8.createElement(TitleImage, {
    data: titleImage
  })), brandLogos.length > 0 && /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    justifyContent: "center",
    alignItems: "center",
    space: "four"
  }, brandLogos.map(logo => {
    return /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, {
      key: logo.description
    }, /* @__PURE__ */React8.createElement(EGDSGraphic, {
      data: logo,
      markSize: 6
    }));
  }))));
};
BrandAssets.fragment = fragment;
BrandAssets.displayName = "BrandAssets";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/onboarding-button.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";

// ../internal/src/components/egds-button/egds-button.tsx
import React9 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSOverlayButton, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/hooks/use-gss-redirect-url.tsx
import { useEffect, useState as useState2 } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
var HOTWIRE = 30031;
var useGssRedirectUrl = baseUrl => {
  const hasRedirectUrl = baseUrl.indexOf("uurl") > -1;
  const currentLocation = useLocation();
  const getCurrentLocation = () => ({
    pathname: `${currentLocation.pathname}`,
    search: `${currentLocation.search}`,
    hash: `${currentLocation.hash}`
  });
  function getReturnUrlParam(location2, siteId2) {
    const {
      pathname,
      search,
      hash
    } = location2;
    const returnUrl = pathname.concat(search, hash);
    switch (siteId2) {
      case HOTWIRE:
        return `&redirectUrl=targeturl=${encodeURIComponent(returnUrl)}&referrerId=wl_prod`;
      default:
        return `&uurl=${encodeURIComponent(`e3id=redr&rurl=${returnUrl}`)}`;
    }
  }
  const {
    context
  } = useBexApi2();
  const [location, setLocation] = useState2(getCurrentLocation);
  const siteId = context == null ? void 0 : context.siteId;
  useEffect(() => {
    const handleLocationChange = () => setLocation(getCurrentLocation());
    window.addEventListener("popstate", handleLocationChange);
    return () => window.removeEventListener("popstate", handleLocationChange);
  }, [getCurrentLocation]);
  let authURL = "";
  if (!hasRedirectUrl) {
    authURL = baseUrl + (baseUrl.indexOf("?") !== -1 ? "" : "?") + getReturnUrlParam(location || {}, siteId);
  }
  return authURL;
};

// ../internal/src/utils/link-mapper.ts
var UILinkTargetMap = {
  ["EXTERNAL" /* EXTERNAL */]: "_blank",
  ["INTERNAL" /* INTERNAL */]: "_self"
};
var linkSizeMapper = {
  ["SMALL" /* SMALL */]: "small",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["LARGE" /* LARGE */]: "large"
};

// ../internal/src/components/egds-button/button-action-helpers.ts
var getLoyaltyUILinkActionPath = action => {
  if (action.resource.__typename !== "HttpURI") {
    return null;
  }
  return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLoyaltyUILinkActionTarget = action => UILinkTargetMap[action.target];

// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql7`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    accessibility
    disabled
    analytics {
      linkName
      referrerId
    }
    icon {
      description
      id
      title
      token
      theme
    }
    action {
      ...ButtonLinkActionFragment
    }
  }

  fragment ButtonLinkActionFragment on UILinkAction {
    resource {
      ...HttpURIFragment
    }
    target
    useRelativePath
  }

  fragment HttpURIFragment on HttpURI {
    relativePath
    value
  }
`;
var deriveLinkProps = action => {
  if ((action == null ? void 0 : action.__typename) !== "UILinkAction") {
    return {};
  }
  const path = getLoyaltyUILinkActionPath(action);
  if (!path) {
    return {};
  }
  return {
    href: path,
    target: getLoyaltyUILinkActionTarget(action),
    tag: "a"
  };
};
var LoyaltyEGDSButton = ({
  className,
  dataStid,
  domRef,
  href,
  isFullWidth,
  onClickHandler,
  size,
  inverse,
  isDisabled,
  isNoTextAllowed,
  data: {
    __typename,
    accessibility,
    primary,
    disabled,
    analytics,
    action,
    icon
  }
}) => {
  var _a, _b, _c, _d, _e;
  const clickTracker = useClickTracker();
  const linkProps = deriveLinkProps(action);
  const urlWithRedirect = useGssRedirectUrl((_a = linkProps.href) != null ? _a : "");
  const handleOnClick = React9.useCallback(event => {
    onClickHandler == null ? void 0 : onClickHandler(event);
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  }, [onClickHandler, clickTracker, analytics]);
  if (!primary && !isNoTextAllowed) {
    return null;
  }
  if ((linkProps == null ? void 0 : linkProps.href) && urlWithRedirect) {
    linkProps.href = urlWithRedirect;
  }
  const buttonProps = __spreadValues({
    "aria-label": accessibility != null ? accessibility : void 0,
    className,
    disabled: isDisabled || disabled,
    href,
    isFullWidth,
    onClick: handleOnClick,
    size,
    domRef
  }, linkProps);
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React9.createElement(EGDSPrimaryButton, __spreadProps(__spreadValues({}, buttonProps), {
        "data-stid": dataStid,
        inverse
      }), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React9.createElement(EGDSSecondaryButton, __spreadProps(__spreadValues({}, buttonProps), {
        "data-stid": dataStid,
        inverse
      }), primary);
    case "UITertiaryButton":
      return /* @__PURE__ */React9.createElement(EGDSTertiaryButton, __spreadProps(__spreadValues({}, buttonProps), {
        "data-stid": dataStid,
        inverse
      }), icon && /* @__PURE__ */React9.createElement(EGDSIcon2, {
        description: icon.description,
        id: icon.id,
        name: icon.token,
        title: (_b = icon.title) != null ? _b : void 0,
        theme: (_c = icon.theme) != null ? _c : void 0
      }), primary);
    case "EGDSOverlayButton":
      return /* @__PURE__ */React9.createElement(EGDSOverlayButton, __spreadProps(__spreadValues({}, buttonProps), {
        "data-stid": dataStid
      }), icon && /* @__PURE__ */React9.createElement(EGDSIcon2, {
        description: icon.description,
        id: icon.id,
        name: icon.token,
        title: (_d = icon.title) != null ? _d : void 0,
        theme: (_e = icon.theme) != null ? _e : void 0
      }), primary);
    default:
      return null;
  }
};
LoyaltyEGDSButton.fragment = _Fragment;
LoyaltyEGDSButton.displayName = "LoyaltyEGDSButton";

// src/hooks/use-onboarding-button.ts
import { useCallback as useCallback5, useEffect as useEffect2 } from "react";
import { liveAnnounce } from "@egds/react-core/utils";

// src/components/one-key-onboarding/providers/mutation-progress-provider.tsx
import React10, { createContext as createContext3, useCallback as useCallback4, useContext as useContext3, useMemo as useMemo3, useState as useState3 } from "react";
var MutationProgressContext = createContext3({
  isMutationInProgress: false,
  setIsMutationInProgress: () => void 0
});
var MutationProgressProvider = ({
  mockedContext,
  children
}) => {
  const [isMutationInProgress, setIsMutationInProgress] = useState3(false);
  const handleMutationProgressChange = useCallback4(state => {
    setIsMutationInProgress(state);
  }, []);
  const context = useMemo3(() => ({
    isMutationInProgress,
    setIsMutationInProgress: handleMutationProgressChange
  }), [isMutationInProgress, handleMutationProgressChange]);
  return /* @__PURE__ */React10.createElement(MutationProgressContext.Provider, {
    value: mockedContext || context
  }, children);
};
var useMutationProgressContext = () => useContext3(MutationProgressContext);

// src/hooks/use-onboarding-button.ts
var useOnboardingButton = ({
  button,
  onNullActionClick,
  onOperationSuccess,
  onOperationFailure,
  onOperationError
}) => {
  const {
    closeDialog
  } = useOnboardingDialogContext();
  const {
    proceedWithOnboardingFlow
  } = useOnboardingUtils();
  const {
    setIsMutationInProgress
  } = useMutationProgressContext();
  const [onboardingOperation, {
    called: isOnboardingOperationInProgress
  }] = useUniversalOnboardingOperation(getUniversalOnboardingActionType(button.action));
  useEffect2(() => {
    setIsMutationInProgress(isOnboardingOperationInProgress);
  }, [setIsMutationInProgress, isOnboardingOperationInProgress]);
  const handleDismissAction = useCallback5(() => {
    closeDialog();
  }, [closeDialog]);
  const handleUILinkAction = useCallback5(action => {
    liveAnnounce(action.accessibility || void 0);
    navigateToLink(action);
  }, []);
  const handleSecondaryActionOrFallbackAction = useCallback5(fallbackAction => {
    var _a;
    switch ((_a = button.secondaryAction) == null ? void 0 : _a.__typename) {
      case "EGDSDismissAction":
        handleDismissAction();
        return;
      case "UILinkAction":
        handleUILinkAction(button.secondaryAction);
        return;
      default:
        fallbackAction();
    }
  }, [button.secondaryAction, handleDismissAction, handleUILinkAction]);
  const handleOperationResult = useCallback5(result => {
    var _a, _b;
    switch ((_b = (_a = result.data) == null ? void 0 : _a.oneKeyUniversalOnboardingOperation) == null ? void 0 : _b.operationStatus) {
      case "SUCCEEDED" /* SUCCEEDED */:
        onOperationSuccess == null ? void 0 : onOperationSuccess();
        handleSecondaryActionOrFallbackAction(proceedWithOnboardingFlow);
        break;
      case "FAILED" /* FAILED */:
        onOperationFailure == null ? void 0 : onOperationFailure(result);
        handleSecondaryActionOrFallbackAction(proceedWithOnboardingFlow);
        break;
      case "FAILED_BLOCKING" /* FAILED_BLOCKING */:
        onOperationFailure == null ? void 0 : onOperationFailure(result);
        navigateToErrorPage();
        break;
      default:
        onOperationFailure == null ? void 0 : onOperationFailure(result);
        handleSecondaryActionOrFallbackAction(proceedWithOnboardingFlow);
    }
  }, [onOperationSuccess, onOperationFailure, handleSecondaryActionOrFallbackAction, proceedWithOnboardingFlow]);
  const handleOnboardingButtonClick = useCallback5(() => {
    var _a;
    switch ((_a = button.action) == null ? void 0 : _a.__typename) {
      case "OneKeyUniversalOnboardingOperationAction":
        onboardingOperation().then(result => {
          handleOperationResult(result);
        }).catch(error => {
          onOperationError == null ? void 0 : onOperationError(error);
          navigateToErrorPage();
        });
        return;
      case "EGDSDismissAction":
        handleDismissAction();
        return;
      case "UILinkAction":
        handleUILinkAction(button.action);
        return;
      default:
        handleSecondaryActionOrFallbackAction(onNullActionClick);
    }
  }, [button.action, onboardingOperation, handleOperationResult, handleSecondaryActionOrFallbackAction, onOperationError, handleDismissAction, handleUILinkAction, onNullActionClick]);
  return {
    handleOnboardingButtonClick
  };
};

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/onboarding-button.tsx
var fragment2 = gql8`
  fragment OnboardingButtonFragment on OneKeyUniversalOnboardingButton {
    button {
      ...EGDSButtonFragment
    }
    action {
      ...OneKeyUniversalOnboardingButtonActionFragment
    }
    secondaryAction {
      ...OneKeyUniversalOnboardingButtonActionFragment
    }
  }

  fragment OneKeyUniversalOnboardingButtonActionFragment on OneKeyUniversalOnboardingButtonAction {
    ...OneKeyUniversalOnboardingButtonDismissActionFragment
    ...OneKeyUniversalOnboardingButtonUILinkActionFragment
    ...OneKeyUniversalOnboardingOperationActionFragment
  }

  fragment OneKeyUniversalOnboardingButtonDismissActionFragment on EGDSDismissAction {
    accessibility
    analytics {
      linkName
      referrerId
    }
    label
  }

  fragment OneKeyUniversalOnboardingButtonUILinkActionFragment on UILinkAction {
    accessibility
    analytics {
      linkName
      referrerId
    }
    resource {
      value
      ...ButtonHttpURIFragment
    }
    target
    useRelativePath
  }

  fragment OneKeyUniversalOnboardingOperationActionFragment on OneKeyUniversalOnboardingOperationAction {
    actionType
  }

  fragment ButtonHttpURIFragment on HttpURI {
    relativePath
  }

  ${LoyaltyEGDSButton.fragment}
`;
var OnboardingButton = ({
  data,
  size,
  isFullWidth,
  isNoTextAllowed,
  dataStid,
  domRef,
  onNullActionClick,
  onOperationSuccess,
  onOperationFailure,
  onOperationError
}) => {
  const {
    isMutationInProgress
  } = useMutationProgressContext();
  const {
    handleOnboardingButtonClick
  } = useOnboardingButton({
    button: data,
    onNullActionClick,
    onOperationSuccess,
    onOperationFailure,
    onOperationError
  });
  return /* @__PURE__ */React11.createElement(LoyaltyEGDSButton, {
    data: data.button,
    domRef,
    isDisabled: isMutationInProgress,
    isFullWidth,
    size,
    isNoTextAllowed,
    dataStid,
    onClickHandler: handleOnboardingButtonClick
  });
};
OnboardingButton.fragment = fragment2;
OnboardingButton.displayName = "OnboardingButton";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/onboarding-link.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";

// ../internal/src/components/egds-text/egds-standard-link.tsx
import React12 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment3 = gql9`
  fragment EGDSStandardLinkFragment on EGDSStandardLink {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
        ... on HttpURI {
          relativePath
        }
      }
      target
      useRelativePath
    }
    disabled
    standardLinkIcon: icon {
      ...EGDSIconFragment
    }
    iconPosition
    size
    text
  }
  ${LoyaltyEGDSIcon.fragment}
`;
var getHrefFromLinkAction = ({
  resource,
  useRelativePath
}) => {
  switch (resource.__typename) {
    case "HttpURI":
      return useRelativePath ? resource.relativePath : resource.value;
    default:
      return resource.value;
  }
};
var IconPlacement = ({
  icon,
  iconPosition,
  iconPositionToMatch
}) => {
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React12.createElement(LoyaltyEGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = ({
  className,
  dataStid,
  inline,
  theme,
  align,
  size,
  data,
  onClickHandler
}) => {
  const {
    action: {
      analytics,
      target,
      accessibility
    },
    disabled,
    iconPosition,
    standardLinkIcon,
    size: serverSize,
    text
  } = data;
  const clickTracker = useClickTracker2();
  const onClick = React12.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
    if (onClickHandler) {
      onClickHandler();
    }
  }, [clickTracker, analytics]);
  const getPath2 = React12.useCallback(() => {
    return getHrefFromLinkAction(data.action);
  }, [data.action]);
  return /* @__PURE__ */React12.createElement(EGDSLink, {
    className,
    "data-stid": dataStid,
    size: size || linkSizeMapper[serverSize],
    onClickCapture: onClick,
    inline,
    disabled,
    theme: theme || "default",
    align
  }, /* @__PURE__ */React12.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath2()
  }, /* @__PURE__ */React12.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React12.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React12.createElement(EGDSText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/onboarding-link.tsx
var fragment4 = gql10`
  fragment OnboardingLinkFragment on OneKeyUniversalOnboardingLink {
    button {
      ...OnboardingButtonFragment
    }
    link {
      ...EGDSStandardLinkFragment
    }
  }

  ${OnboardingButton.fragment}
  ${EGDSStandardLink.fragment}
`;
var getUILinkActionPath = action => {
  if (action.resource.__typename !== "HttpURI") {
    return void 0;
  }
  return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getUILinkActionTarget = action => UILinkTargetMap[action.target];
var OnboardingLink = props => {
  var _a;
  const {
    data,
    isButton
  } = props;
  const {
    button,
    link
  } = data;
  if (isButton) {
    const {
      size: size2,
      isFullWidth
    } = props;
    return ((_a = button.action) == null ? void 0 : _a.__typename) === "UILinkAction" && /* @__PURE__ */React13.createElement(EGDSTertiaryButton2, {
      tag: "a",
      href: getUILinkActionPath(button.action),
      target: getUILinkActionTarget(button.action),
      size: size2,
      isFullWidth
    }, button.button.primary);
  }
  const {
    align,
    size
  } = props;
  return /* @__PURE__ */React13.createElement(EGDSStandardLink, {
    data: link,
    align,
    size
  });
};
OnboardingLink.fragment = fragment4;
OnboardingLink.displayName = "OnboardingLink";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/brand-assets-spacing.tsx
import React14 from "react";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { ViewExtraLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var BrandAssetsSpacing = ({
  children
}) => /* @__PURE__ */React14.createElement(Viewport2, null, /* @__PURE__ */React14.createElement(ViewSmall2, null, /* @__PURE__ */React14.createElement(EGDSSpacing, {
  padding: {
    inline: "six",
    block: "eight"
  }
}, /* @__PURE__ */React14.createElement("div", null, children))), /* @__PURE__ */React14.createElement(ViewMedium2, null, /* @__PURE__ */React14.createElement(EGDSSpacing, {
  padding: {
    inline: "six",
    block: "twelve"
  }
}, /* @__PURE__ */React14.createElement("div", null, children))), /* @__PURE__ */React14.createElement(ViewExtraLarge, null));
BrandAssetsSpacing.displayName = "BrandAssetsSpacing";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/consent-link.tsx
import React15 from "react";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var ConsentLink = ({
  data
}) => /* @__PURE__ */React15.createElement(Viewport3, null, /* @__PURE__ */React15.createElement(ViewSmall3, null, /* @__PURE__ */React15.createElement(OnboardingLink, {
  data,
  align: "center",
  size: "small"
})), /* @__PURE__ */React15.createElement(ViewMedium3, null, /* @__PURE__ */React15.createElement(OnboardingLink, {
  data,
  align: "center",
  size: "large"
})));
ConsentLink.displayName = "ConsentLink";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/consent-section-layout.tsx
import React16 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var ConsentSectionLayout = ({
  children
}) => /* @__PURE__ */React16.createElement(Viewport4, null, /* @__PURE__ */React16.createElement(ViewSmall4, null, /* @__PURE__ */React16.createElement(EGDSLayoutFlex2, {
  direction: "column",
  space: "two"
}, children)), /* @__PURE__ */React16.createElement(ViewMedium4, null, /* @__PURE__ */React16.createElement(EGDSLayoutFlex2, {
  direction: "column",
  space: "four"
}, children)));
ConsentSectionLayout.displayName = "ConsentSectionLayout";
var ConsentSectionLayoutItem = ({
  children
}) => /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem2, null, children);
ConsentSectionLayoutItem.displayName = "ConsentSectionLayoutItem";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/consent-text.tsx
import React17 from "react";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
var ConsentText = ({
  children
}) => /* @__PURE__ */React17.createElement(Viewport5, null, /* @__PURE__ */React17.createElement(ViewSmall5, null, /* @__PURE__ */React17.createElement(EGDSText2, {
  align: "center",
  size: 200
}, children)), /* @__PURE__ */React17.createElement(ViewMedium5, null, /* @__PURE__ */React17.createElement(EGDSText2, {
  align: "center",
  size: 400
}, children)));
ConsentText.displayName = "ConsentText";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/content-spacing.tsx
import React18 from "react";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
var ContentSpacing = ({
  children
}) => /* @__PURE__ */React18.createElement(Viewport6, null, /* @__PURE__ */React18.createElement(ViewSmall6, null, /* @__PURE__ */React18.createElement(EGDSSpacing2, {
  padding: {
    inline: "six",
    block: "eight"
  }
}, children)), /* @__PURE__ */React18.createElement(ViewMedium6, null, /* @__PURE__ */React18.createElement(EGDSSpacing2, {
  padding: {
    inline: "six",
    block: "twelve"
  }
}, children)));
ContentSpacing.displayName = "ContentSpacing";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/cta-section-layout.tsx
import React19 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { ViewMedium as ViewMedium7, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
var CTASectionLayout = ({
  children
}) => /* @__PURE__ */React19.createElement(Viewport7, null, /* @__PURE__ */React19.createElement(ViewSmall7, null, /* @__PURE__ */React19.createElement(EGDSLayoutFlex3, {
  direction: "column",
  space: "large"
}, children)), /* @__PURE__ */React19.createElement(ViewMedium7, null, /* @__PURE__ */React19.createElement(EGDSLayoutFlex3, {
  direction: "column",
  space: "xlarge"
}, children)));
CTASectionLayout.displayName = "CTASectionLayout";
var CTASectionLayoutItem = ({
  children
}) => /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem3, null, children);
CTASectionLayoutItem.displayName = "CTASectionLayoutItem";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/dismiss-button-position.tsx
import React20 from "react";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { ViewLarge, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
var DismissButtonPosition = ({
  children
}) => {
  return /* @__PURE__ */React20.createElement(Viewport8, null, /* @__PURE__ */React20.createElement(ViewSmall8, null, /* @__PURE__ */React20.createElement(EGDSLayoutPosition, {
    position: {
      top: "three",
      left: "three"
    },
    type: "absolute"
  }, children)), /* @__PURE__ */React20.createElement(ViewLarge, null, /* @__PURE__ */React20.createElement(EGDSLayoutPosition, {
    position: {
      top: "six",
      left: "six"
    },
    type: "absolute"
  }, children)));
};
DismissButtonPosition.displayName = "DismissButtonPosition";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/hero-image.tsx
import React22 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/hero-image-figure.tsx
import React21 from "react";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { ViewMedium as ViewMedium8, Viewport as Viewport9, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
var HeroImageFigure = ({
  children
}) => {
  return /* @__PURE__ */React21.createElement("div", null, /* @__PURE__ */React21.createElement(Viewport9, null, /* @__PURE__ */React21.createElement(ViewSmall9, null, /* @__PURE__ */React21.createElement(EGDSFigure, {
    imageFit: "cover",
    ratio: EGDSFigureAspectRatioType.R1_1
  }, children)), /* @__PURE__ */React21.createElement(ViewMedium8, null, /* @__PURE__ */React21.createElement(EGDSFigure, {
    imageFit: "cover",
    ratio: EGDSFigureAspectRatioType.R3_2
  }, children))));
};
HeroImageFigure.displayName = "HeroImageFigure";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/hero-image.tsx
var fragment5 = gql11`
  fragment HeroImageFragment on Image {
    description
    url
  }
`;
var HeroImage = ({
  data,
  children
}) => {
  const {
    url,
    description
  } = data;
  return /* @__PURE__ */React22.createElement(HeroImageFigure, null, /* @__PURE__ */React22.createElement(EGDSImage, {
    src: url,
    alt: description
  }), children && /* @__PURE__ */React22.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: {
      left: "zero",
      bottom: "zero",
      right: "zero"
    }
  }, children));
};
HeroImage.fragment = fragment5;
HeroImage.displayName = "HeroImage";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/learn-more-button.tsx
import React23 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { ViewMedium as ViewMedium9, Viewport as Viewport10, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
var LearnMoreLink = ({
  data
}) => /* @__PURE__ */React23.createElement(Viewport10, null, /* @__PURE__ */React23.createElement(ViewSmall10, null, /* @__PURE__ */React23.createElement(OnboardingLink, {
  data,
  isButton: true,
  size: EGDSButtonSize.SMALL,
  isFullWidth: true
})), /* @__PURE__ */React23.createElement(ViewMedium9, null, /* @__PURE__ */React23.createElement(OnboardingLink, {
  data,
  isButton: true,
  size: EGDSButtonSize.LARGE,
  isFullWidth: true
})));

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/perk.tsx
import React24 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSIcon as EGDSIcon3, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var fragment6 = gql12`
  fragment PerkFragment on OneKeyUniversalOnboardingPerk {
    description
    icon {
      token
    }
  }
`;
var Perk = ({
  data,
  size
}) => {
  const {
    icon,
    description
  } = data;
  return /* @__PURE__ */React24.createElement(EGDSLayoutFlex4, {
    space: "two",
    alignItems: "center",
    justifyContent: icon ? "start" : "center"
  }, icon && /* @__PURE__ */React24.createElement(EGDSIcon3, {
    name: icon.token,
    size: EGDSIconSize2.MEDIUM,
    spotlight: "standard"
  }), /* @__PURE__ */React24.createElement(EGDSText3, {
    align: icon ? "left" : "center",
    size
  }, description));
};
Perk.fragment = fragment6;
Perk.displayName = "Perk";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/perk-container.tsx
import React26 from "react";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium10, Viewport as Viewport11, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/perks.tsx
import React25 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
var Perks = ({
  perks,
  size,
  space
}) => {
  return /* @__PURE__ */React25.createElement(EGDSLayoutFlex5, {
    direction: "column",
    space
  }, perks.map((perk, index) => /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem4, {
    key: index
  }, /* @__PURE__ */React25.createElement(Perk, {
    data: perk,
    size
  }))));
};
Perks.displayName = "Perks";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/perk-container.tsx
var PerkContainer = ({
  perks
}) => /* @__PURE__ */React26.createElement(Viewport11, null, /* @__PURE__ */React26.createElement(ViewSmall11, null, /* @__PURE__ */React26.createElement(EGDSSpacing3, {
  margin: {
    blockend: "two"
  }
}, /* @__PURE__ */React26.createElement("div", null, /* @__PURE__ */React26.createElement(Perks, {
  perks,
  size: 300,
  space: "two"
})))), /* @__PURE__ */React26.createElement(ViewMedium10, null, /* @__PURE__ */React26.createElement(EGDSSpacing3, {
  margin: {
    blockend: "four"
  }
}, /* @__PURE__ */React26.createElement("div", null, /* @__PURE__ */React26.createElement(Perks, {
  perks,
  size: 400,
  space: "four"
})))));
PerkContainer.displayName = "PerkContainer";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/screen-layout.tsx
import React27 from "react";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { ViewExtraLarge as ViewExtraLarge2, Viewport as Viewport12, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
var ScreenLayout = ({
  children
}) => /* @__PURE__ */React27.createElement(Viewport12, null, /* @__PURE__ */React27.createElement(ViewSmall12, null, /* @__PURE__ */React27.createElement(EGDSLayoutGrid, null, children)), /* @__PURE__ */React27.createElement(ViewExtraLarge2, null, /* @__PURE__ */React27.createElement(EGDSLayoutGrid, {
  columns: 2,
  blockSize: "100vb"
}, children)));
ScreenLayout.displayName = "ScreenLayout";
var ScreenLayoutItem = ({
  children
}) => /* @__PURE__ */React27.createElement(EGDSLayoutGridItem, null, children);
ScreenLayoutItem.displayName = "ScreenLayoutItem";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/title.tsx
import React28 from "react";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { ViewMedium as ViewMedium11, Viewport as Viewport13, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
var Title = ({
  children
}) => /* @__PURE__ */React28.createElement(Viewport13, null, /* @__PURE__ */React28.createElement(ViewSmall13, null, /* @__PURE__ */React28.createElement(EGDSSpacing4, {
  margin: {
    blockend: "six"
  }
}, /* @__PURE__ */React28.createElement(EGDSHeading, {
  tag: "h1",
  size: 4,
  align: "center"
}, children))), /* @__PURE__ */React28.createElement(ViewMedium11, null, /* @__PURE__ */React28.createElement(EGDSSpacing4, {
  margin: {
    blockend: "eight"
  }
}, /* @__PURE__ */React28.createElement(EGDSHeading, {
  tag: "h1",
  size: 2,
  align: "center"
}, children))));
Title.displayName = "Title";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/welcome-screen.tsx
var fragment7 = gql13`
  fragment WelcomeScreenFragment on OneKeyUniversalOnboardingWelcomeScreen {
    heroImage {
      ...HeroImageFragment
    }
    brandAssets {
      ...BrandAssetsFragment
    }
    title
    perks {
      ...PerkFragment
    }
    learnMoreLink {
      ...OnboardingLinkFragment
    }
    primaryButton {
      ...OnboardingButtonFragment
    }
    consentText
    termsAndConditionsLink {
      ...OnboardingLinkFragment
    }
    privacyLink {
      ...OnboardingLinkFragment
    }
    dismissButton {
      ...OnboardingButtonFragment
    }
    onLoadOperation {
      actionType
    }
    ariaLabel
  }

  ${OnboardingLink.fragment}
  ${BrandAssets.fragment}
  ${HeroImage.fragment}
  ${OnboardingButton.fragment}
  ${Perk.fragment}
`;
var WelcomeScreen = ({
  data
}) => {
  const {
    heroImage,
    brandAssets,
    title,
    perks,
    learnMoreLink,
    primaryButton,
    consentText,
    termsAndConditionsLink,
    privacyLink,
    dismissButton,
    onLoadOperation,
    ariaLabel
  } = data;
  const impressionClickstreamEventData = {
    event: {
      event_version: "1.0.0",
      event_name: "onekey_welcome_onboarding.viewed",
      event_type: "Page View"
    },
    experience: {
      page_name: "OKOnboarding",
      page_name_detailed: "OKOnboardingWelcomeScreen"
    }
  };
  const isConsentSectionVisible = consentText || termsAndConditionsLink || privacyLink;
  const systemEvents = useLoggerEvents(UNIVERSAL_ONBOARDING_LOGGER_EVENTS);
  const {
    isDialogOpen,
    closeDialog
  } = useOnboardingDialogContext();
  const {
    proceedWithOnboardingFlow
  } = useOnboardingUtils();
  const [onboardingOperation] = useUniversalOnboardingOperation(getUniversalOnboardingActionType(onLoadOperation));
  const handleOperationSuccess = useCallback6(() => {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_SUCCESS.log(stringifyEventPayload({
      message: "Welcome Screen mutation success"
    }));
  }, [systemEvents]);
  const handleOperationFailure = useCallback6(result => {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_FAILURE.log(stringifyEventPayload({
      message: `Welcome Screen mutation failure. Onboarding Operation response: ${JSON.stringify(result.data)}`
    }));
  }, [systemEvents]);
  const handleOperationError = useCallback6(error => {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_ERROR.log(stringifyEventPayload({
      message: "Welcome Screen mutation error",
      error
    }));
  }, [systemEvents]);
  useEffect3(() => {
    if (onLoadOperation) {
      onboardingOperation().then(result => {
        if (isOperationStatusSucceeded(result)) {
          handleOperationSuccess();
        } else {
          handleOperationFailure(result);
        }
      }).catch(error => {
        handleOperationError(error);
        navigateToErrorPage();
      });
    }
  }, []);
  return /* @__PURE__ */React29.createElement(EGDSSheet, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "full",
    ariaLabel
  }, /* @__PURE__ */React29.createElement(EGDSSheetContent, {
    padded: false
  }, /* @__PURE__ */React29.createElement(EgClickstreamImpressionTracker, {
    eventData: impressionClickstreamEventData
  }, /* @__PURE__ */React29.createElement("div", {
    "data-stid": "one-key-onboarding-welcome-screen"
  }, /* @__PURE__ */React29.createElement(ScreenLayout, null, /* @__PURE__ */React29.createElement(ScreenLayoutItem, null, /* @__PURE__ */React29.createElement(HeroImage, {
    data: heroImage
  }, brandAssets && /* @__PURE__ */React29.createElement(BrandAssetsSpacing, null, /* @__PURE__ */React29.createElement(BrandAssets, {
    data: brandAssets
  })))), dismissButton && /* @__PURE__ */React29.createElement(DismissButtonPosition, null, /* @__PURE__ */React29.createElement(OnboardingButton, {
    data: dismissButton,
    size: EGDSButtonSize2.MEDIUM,
    isNoTextAllowed: true,
    dataStid: "one-key-onboarding-welcome-screen-dismiss-button",
    onOperationSuccess: handleOperationSuccess,
    onOperationFailure: handleOperationFailure,
    onOperationError: handleOperationError,
    onNullActionClick: closeDialog
  })), /* @__PURE__ */React29.createElement(ScreenLayoutItem, null, /* @__PURE__ */React29.createElement(ContentSpacing, null, /* @__PURE__ */React29.createElement(EGDSLayoutGrid2, {
    columns: [MinMax("0px", "600px")],
    justifyContent: "center",
    alignItems: "center"
  }, /* @__PURE__ */React29.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React29.createElement(EGDSLayoutFlex6, {
    direction: "column",
    space: "xlarge"
  }, /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem5, null, brandAssets && /* @__PURE__ */React29.createElement(Viewport14, null, /* @__PURE__ */React29.createElement(ViewExtraLarge3, null, /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React29.createElement(BrandAssets, {
    data: brandAssets,
    isAlternateTitleImage: true
  }))))), /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React29.createElement("div", null, /* @__PURE__ */React29.createElement(Title, null, title), perks.length > 0 && /* @__PURE__ */React29.createElement(PerkContainer, {
    perks
  }), /* @__PURE__ */React29.createElement(LearnMoreLink, {
    data: learnMoreLink
  }))), /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React29.createElement(CTASectionLayout, null, isConsentSectionVisible && /* @__PURE__ */React29.createElement(CTASectionLayoutItem, null, /* @__PURE__ */React29.createElement(ConsentSectionLayout, null, consentText && /* @__PURE__ */React29.createElement(ConsentSectionLayoutItem, null, /* @__PURE__ */React29.createElement(ConsentText, null, consentText)), (termsAndConditionsLink || privacyLink) && /* @__PURE__ */React29.createElement(ConsentSectionLayoutItem, null, /* @__PURE__ */React29.createElement(EGDSLayoutFlex6, {
    direction: "column",
    space: "two"
  }, termsAndConditionsLink && /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React29.createElement(ConsentLink, {
    data: termsAndConditionsLink
  })), privacyLink && /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React29.createElement(ConsentLink, {
    data: privacyLink
  })))))), /* @__PURE__ */React29.createElement(CTASectionLayoutItem, null, /* @__PURE__ */React29.createElement(OnboardingButton, {
    data: primaryButton,
    size: EGDSButtonSize2.LARGE,
    isFullWidth: true,
    dataStid: "one-key-onboarding-welcome-screen-primary-button",
    onOperationSuccess: handleOperationSuccess,
    onOperationFailure: handleOperationFailure,
    onOperationError: handleOperationError,
    onNullActionClick: proceedWithOnboardingFlow
  }))))))))))))));
};
WelcomeScreen.fragment = fragment7;
WelcomeScreen.displayName = "WelcomeScreen";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/contextual-screen.tsx
import React56, { useCallback as useCallback9 } from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize4 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex11, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3, MinMax as MinMax2 } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet3, EGDSSheetContent as EGDSSheetContent3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";

// ../internal/src/components/egds-loyalty-badge/egds-loyalty-badge.tsx
import React30 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSBadgeLoyalty } from "@egds/react-core/badge";

// ../internal/src/components/egds-loyalty-badge/__private/egds-loyalty-badge-sizes.ts
var loyaltyBadgeSizes = {
  small: "small",
  large: "large"
};

// ../internal/src/components/egds-loyalty-badge/__private/egds-loyalty-badge-theme.ts
var loyaltyBadgeThemes = {
  lowtier: "lowtier",
  midtier: "midtier",
  hightier: "hightier",
  vip: "vip",
  extrahightier: "extrahightier",
  "global-lowtier": "global-lowtier",
  "global-middletier": "global-middletier",
  "global-hightier": "global-hightier",
  "global-extrahightier": "global-extrahightier"
};

// ../internal/src/components/egds-loyalty-badge/egds-loyalty-badge.tsx
var fragment8 = gql14`
  fragment EGDSLoyaltyBadgeFragment on EGDSLoyaltyBadge {
    accessibility
    badgeText: text
    size
    badgeTheme: theme
  }
`;
var EGDSLoyaltyBadge = props => {
  const {
    data
  } = props;
  if (!data.badgeText) {
    return null;
  }
  const {
    size,
    badgeTheme,
    accessibility,
    badgeText
  } = data;
  const selectedTheme = badgeTheme ? loyaltyBadgeThemes[badgeTheme] : void 0;
  const selectedSize = size ? loyaltyBadgeSizes[size] : void 0;
  return /* @__PURE__ */React30.createElement(EGDSBadgeLoyalty, {
    a11yText: accessibility != null ? accessibility : void 0,
    text: badgeText,
    size: selectedSize,
    theme: selectedTheme
  });
};
EGDSLoyaltyBadge.fragment = fragment8;
EGDSLoyaltyBadge.displayName = "EGDSLoyaltyBadge";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/balance-section.tsx
import React31 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { useViewportMap, ViewMedium as ViewMedium12, Viewport as Viewport15, ViewSizes, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
var fragment9 = gql15`
  fragment BalanceSectionFragment on OneKeyUniversalContextualOnboardingBalance {
    title
    balance
    subTitles
  }
`;
var subTitlesSizeMap = {
  [ViewSizes.SMALL]: 300,
  [ViewSizes.MEDIUM]: 400
};
var BalanceSection = ({
  data
}) => {
  const {
    title,
    balance,
    subTitles
  } = data;
  const subTitleSize = useViewportMap(subTitlesSizeMap);
  return /* @__PURE__ */React31.createElement("div", null, /* @__PURE__ */React31.createElement(Viewport15, null, /* @__PURE__ */React31.createElement(ViewSmall14, null, /* @__PURE__ */React31.createElement(EGDSSpacing5, {
    margin: {
      blockend: "one"
    }
  }, /* @__PURE__ */React31.createElement(EGDSText4, {
    size: 200,
    align: "center"
  }, title))), /* @__PURE__ */React31.createElement(ViewMedium12, null, /* @__PURE__ */React31.createElement(EGDSSpacing5, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React31.createElement(EGDSText4, {
    size: 300,
    align: "center"
  }, title)))), /* @__PURE__ */React31.createElement(EGDSText4, {
    size: 700,
    align: "center",
    weight: "medium"
  }, balance), subTitles.length > 0 && /* @__PURE__ */React31.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React31.createElement("div", null, subTitles.map((subTitle, index) => /* @__PURE__ */React31.createElement(EGDSText4, {
    key: index,
    size: subTitleSize,
    align: "center"
  }, subTitle)))));
};
BalanceSection.fragment = fragment9;
BalanceSection.displayName = "BalanceSection";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/benefit.tsx
import React32 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSListItem } from "@egds/react-core/list";
var fragment10 = gql16`
  fragment BenefitFragment on OneKeyUniversalContextualOnboardingBenefit {
    icon {
      token
    }
    description
  }
`;
var Benefit = ({
  data
}) => {
  const {
    icon,
    description
  } = data;
  return /* @__PURE__ */React32.createElement(EGDSListItem, null, /* @__PURE__ */React32.createElement(EGDSIcon4, {
    name: icon.token,
    size: EGDSIconSize3.SMALL
  }), description);
};
Benefit.fragment = fragment10;
Benefit.displayName = "Benefit";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/benefits.tsx
import React33 from "react";
import { EGDSList } from "@egds/react-core/list";
import { useViewportMap as useViewportMap2, ViewSizes as ViewSizes2 } from "@shared-ui/viewport-context";
var listSizeMap = {
  [ViewSizes2.SMALL]: 2,
  [ViewSizes2.MEDIUM]: 1
};
var Benefits = ({
  benefits
}) => {
  const listSize = useViewportMap2(listSizeMap);
  return /* @__PURE__ */React33.createElement(EGDSList, {
    bullet: "icon-alternate",
    size: listSize
  }, benefits.map((benefit, index) => /* @__PURE__ */React33.createElement(Benefit, {
    key: index,
    data: benefit
  })));
};
Benefits.displayName = "Benefits";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/benefits-spacing.tsx
import React34 from "react";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium13, Viewport as Viewport16, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
var BenefitsSpacing = ({
  children
}) => /* @__PURE__ */React34.createElement(Viewport16, null, /* @__PURE__ */React34.createElement(ViewSmall15, null, /* @__PURE__ */React34.createElement(EGDSSpacing6, {
  padding: {
    blockend: "two"
  }
}, /* @__PURE__ */React34.createElement("div", null, children))), /* @__PURE__ */React34.createElement(ViewMedium13, null, /* @__PURE__ */React34.createElement(EGDSSpacing6, {
  padding: {
    blockend: "four"
  }
}, /* @__PURE__ */React34.createElement("div", null, children))));
BenefitsSpacing.displayName = "BenefitsSpacing";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/block-spacing.tsx
import React35 from "react";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium14, Viewport as Viewport17, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
var BlockSpacing = ({
  children
}) => /* @__PURE__ */React35.createElement(Viewport17, null, /* @__PURE__ */React35.createElement(ViewSmall16, null, /* @__PURE__ */React35.createElement(EGDSSpacing7, {
  padding: {
    block: "six"
  }
}, children)), /* @__PURE__ */React35.createElement(ViewMedium14, null, /* @__PURE__ */React35.createElement(EGDSSpacing7, {
  padding: {
    block: "sixteen"
  }
}, children)), /* @__PURE__ */React35.createElement(ViewLarge2, null, /* @__PURE__ */React35.createElement(EGDSSpacing7, {
  padding: {
    block: "twelve"
  }
}, children)));
BlockSpacing.displayName = "BlockSpacing";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/brand-assets-spacing.tsx
import React36 from "react";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium15, Viewport as Viewport18, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
var BrandAssetsSpacing2 = ({
  children
}) => /* @__PURE__ */React36.createElement(Viewport18, null, /* @__PURE__ */React36.createElement(ViewSmall17, null, /* @__PURE__ */React36.createElement(EGDSSpacing8, {
  margin: {
    blockend: "eight"
  }
}, /* @__PURE__ */React36.createElement("div", null, children))), /* @__PURE__ */React36.createElement(ViewMedium15, null, /* @__PURE__ */React36.createElement(EGDSSpacing8, {
  margin: {
    blockend: "sixteen"
  }
}, /* @__PURE__ */React36.createElement("div", null, children))), /* @__PURE__ */React36.createElement(ViewLarge3, null, /* @__PURE__ */React36.createElement(EGDSSpacing8, {
  margin: {
    blockend: "eight"
  }
}, /* @__PURE__ */React36.createElement("div", null, children))));
BrandAssetsSpacing2.displayName = "BrandAssetsSpacing";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/card-with-spacing.tsx
import React37 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium16, Viewport as Viewport19, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
var CardWithSpacing = ({
  children
}) => /* @__PURE__ */React37.createElement(Viewport19, null, /* @__PURE__ */React37.createElement(ViewSmall18, null, /* @__PURE__ */React37.createElement(EGDSCard, {
  border: true
}, /* @__PURE__ */React37.createElement(EGDSSpacing9, {
  padding: {
    block: "six",
    inline: "eight"
  }
}, /* @__PURE__ */React37.createElement("div", null, children)))), /* @__PURE__ */React37.createElement(ViewMedium16, null, /* @__PURE__ */React37.createElement(EGDSCard, {
  border: true
}, /* @__PURE__ */React37.createElement(EGDSSpacing9, {
  padding: {
    block: "eight",
    inline: "twelve"
  }
}, /* @__PURE__ */React37.createElement("div", null, children)))));
CardWithSpacing.displayName = "CardWithSpacing";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/content-spacing.tsx
import React38 from "react";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium17, Viewport as Viewport20, ViewSmall as ViewSmall19 } from "@shared-ui/viewport-context";
var ContentSpacing2 = ({
  children
}) => /* @__PURE__ */React38.createElement(Viewport20, null, /* @__PURE__ */React38.createElement(ViewSmall19, null, /* @__PURE__ */React38.createElement(EGDSSpacing10, {
  padding: {
    inline: "six"
  }
}, children)), /* @__PURE__ */React38.createElement(ViewMedium17, null, /* @__PURE__ */React38.createElement(EGDSSpacing10, {
  padding: {
    inline: "sixteen"
  }
}, children)), /* @__PURE__ */React38.createElement(ViewLarge4, null, /* @__PURE__ */React38.createElement(EGDSSpacing10, {
  padding: {
    inline: "twelve"
  }
}, children)));
ContentSpacing2.displayName = "ContentSpacing";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/info-section.tsx
import React53, { useCallback as useCallback7, useRef } from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize3 } from "@egds/react-core/button";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";

// ../internal/src/components/loyalty-universal-popup-dialog/loyalty-universal-popup-dialog.tsx
import React52, { useEffect as useEffect4 } from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/loyalty-universal-popup-button/loyalty-universal-popup-button.tsx
import React39 from "react";
import { gql as gql17 } from "@apollo/client";
var fragment11 = gql17`
  fragment LoyaltyUniversalPopUpButtonFragment on LoyaltyUniversalPopUpButton {
    button {
      ...EGDSButtonFragment
    }
  }
  ${LoyaltyEGDSButton.fragment}
`;
var LoyaltyUniversalPopUpButton = ({
  data,
  isFullWidth,
  onClickHandler
}) => {
  return /* @__PURE__ */React39.createElement(LoyaltyEGDSButton, {
    onClickHandler,
    data: data.button,
    isFullWidth
  });
};
LoyaltyUniversalPopUpButton.fragment = fragment11;
LoyaltyUniversalPopUpButton.displayName = "LoyaltyUniversalPopUpButton";

// ../internal/src/components/loyalty-universal-popup-dialog/loyalty-universal-popup-dialog-section.tsx
import React51 from "react";
import { gql as gql29 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";

// ../internal/src/components/loyalty-universal-popup-dialog/loyalty-universal-popup-section-content-types.tsx
import React50 from "react";
import { gql as gql28 } from "@apollo/client";

// ../internal/src/components/egds-text/egds-plain-text.tsx
import React40 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
var fragment12 = gql18`
  fragment EGDSPlainTextFragment on EGDSPlainText {
    text
  }
`;
var EGDSPlainText = ({
  className,
  inline,
  size,
  theme,
  data
}) => {
  const {
    text
  } = data;
  return /* @__PURE__ */React40.createElement(EGDSText5, {
    className,
    inline,
    size,
    theme
  }, text);
};
EGDSPlainText.fragment = fragment12;
EGDSPlainText.displayName = "EGDSPlainText";

// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React41 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";

// ../internal/src/utils/text-mapper.ts
var TextThemeMapper = /* @__PURE__ */(TextThemeMapper2 => {
  TextThemeMapper2["INVERSE"] = "inverse";
  TextThemeMapper2["LOYALTY"] = "loyalty";
  TextThemeMapper2["NEGATIVE"] = "negative";
  TextThemeMapper2["POSITIVE"] = "positive";
  TextThemeMapper2["PENDING"] = "default";
  return TextThemeMapper2;
})(TextThemeMapper || {});
var sizeMapper = {
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
};
var textWeightMapper = {
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
};

// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment13 = gql19`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    __typename
    stylizedText: text
    theme
    weight
    textSize: size
  }
`;
var EGDSStylizedText = ({
  data,
  whiteSpace,
  useBackendTheme = true,
  align,
  inline
}) => {
  const {
    stylizedText,
    theme,
    weight,
    textSize
  } = data;
  const themeToUse = useBackendTheme && theme ? TextThemeMapper[theme] : void 0;
  return /* @__PURE__ */React41.createElement(EGDSText6, {
    theme: themeToUse,
    align,
    whiteSpace,
    weight: weight ? textWeightMapper[weight] : void 0,
    size: textSize ? sizeMapper[textSize] : void 0,
    inline
  }, stylizedText);
};
EGDSStylizedText.fragment = fragment13;
EGDSStylizedText.displayName = "EGDSStylizedText";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React45, { Fragment } from "react";
import { gql as gql23 } from "@apollo/client";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-inline-content.tsx
import React44 from "react";
import { gql as gql22 } from "@apollo/client";

// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
import React43 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSLink as EGDSLink3, EGDSLinkSizes } from "@egds/react-core/link";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-inline-link-wrapper/ui-link-action.tsx
import React42 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker3, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var fragment14 = gql20`
  fragment UILinkActionFragment on UILinkAction {
    accessibility
    target
    resource {
      __typename
      value
    }
    analytics {
      referrerId
      linkName
    }
  }
`;
var UILinkAction = ({
  children,
  data,
  onClick,
  size,
  disabled,
  isButton,
  inline,
  clickstreamAnalyticsData
}) => {
  const {
    resource,
    analytics,
    accessibility
  } = data;
  const clickTracker = useClickTracker3();
  const track = useEgClickstream();
  const onClickCapture = React42.useCallback(() => {
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
    if ((clickstreamAnalyticsData == null ? void 0 : clickstreamAnalyticsData.serverPayload) && (clickstreamAnalyticsData == null ? void 0 : clickstreamAnalyticsData.eventName) && (clickstreamAnalyticsData == null ? void 0 : clickstreamAnalyticsData.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: clickstreamAnalyticsData.eventName,
            event_version: clickstreamAnalyticsData.eventVersion
          }
        },
        serverPayload: clickstreamAnalyticsData.serverPayload
      });
    }
  }, [analytics, clickstreamAnalyticsData, clickTracker, track]);
  return isButton ? /* @__PURE__ */React42.createElement(EGDSLink2, {
    onClick,
    size,
    disabled,
    inline
  }, /* @__PURE__ */React42.createElement("button", {
    type: "button",
    onClickCapture,
    "aria-label": accessibility || ""
  }, children)) : /* @__PURE__ */React42.createElement("a", {
    href: resource.value,
    onClickCapture,
    "aria-label": accessibility || ""
  }, children);
};
UILinkAction.fragment = fragment14;
UILinkAction.displayName = "UILinkAction";

// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
var fragment15 = gql21`
  fragment EGDSInlineLinkFragment on EGDSInlineLink {
    __typename
    action {
      ...UILinkActionFragment
    }
    disabled
    text
    size
  }
  ${UILinkAction.fragment}
`;
var EGDSInlineLink = ({
  data,
  onClickHandler
}) => {
  const {
    action,
    disabled,
    size,
    text
  } = data;
  const clickTracker = useClickTracker4();
  const onClick = React43.useCallback(() => {
    clickTracker(action.analytics.referrerId, action.analytics.linkName);
    if (onClickHandler) {
      onClickHandler();
    }
  }, [clickTracker, action.analytics]);
  return /* @__PURE__ */React43.createElement(EGDSLink3, {
    onClick,
    inline: true,
    disabled,
    size: EGDSLinkSizes[size]
  }, /* @__PURE__ */React43.createElement("a", {
    href: action.resource.value,
    target: action.target
  }, text, action.accessibility && /* @__PURE__ */React43.createElement("span", {
    className: "is-visually-hidden"
  }, action.accessibility)));
};
EGDSInlineLink.fragment = fragment15;
EGDSInlineLink.displayName = "EGDSInlineLink";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-inline-content.tsx
var fragment16 = gql22`
  fragment EGDSSpannableTextInlineContentFragment on EGDSSpannableTextItem {
    ...EGDSStylizedTextFragment
    ...EGDSPlainTextFragment
    ...EGDSStandardLinkFragment
    ...EGDSInlineLinkFragment
  }

  ${EGDSStylizedText.fragment}
  ${EGDSPlainText.fragment}
  ${EGDSStandardLink.fragment}
  ${EGDSInlineLink.fragment}
`;
var EGDSSpannableTextInlineContent = ({
  size,
  align,
  theme,
  data
}) => {
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React44.createElement(EGDSStylizedText, {
        align,
        data,
        inline: true
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React44.createElement(EGDSPlainText, {
        data,
        size,
        theme,
        inline: true
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React44.createElement(EGDSStandardLink, {
        data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React44.createElement(EGDSInlineLink, {
        data
      });
    default:
      return null;
  }
};
EGDSSpannableTextInlineContent.fragment = fragment16;
EGDSSpannableTextInlineContent.displayName = "EGDSSpannableTextInlineContent";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment17 = gql23`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    inlineContent {
      ...EGDSSpannableTextInlineContentFragment
    }
  }

  ${EGDSSpannableTextInlineContent.fragment}
`;
var EGDSSpannableText = ({
  align,
  data,
  size,
  theme
}) => {
  var _a;
  if ((_a = data == null ? void 0 : data.inlineContent) == null ? void 0 : _a.length) {
    return /* @__PURE__ */React45.createElement(React45.Fragment, null, data.inlineContent.map((item, index) => /* @__PURE__ */React45.createElement(Fragment, {
      key: `inline-content-${index}`
    }, /* @__PURE__ */React45.createElement(EGDSSpannableTextInlineContent, {
      align,
      data: item,
      size,
      theme
    }), " ")));
  }
  return null;
};
EGDSSpannableText.fragment = fragment17;
EGDSSpannableText.displayName = "EGDSSpannableText";

// ../internal/src/components/egds-text/egds-text.tsx
import React46 from "react";
import { gql as gql24 } from "@apollo/client";
var fragment18 = gql24`
  fragment EGDSTextFragment on EGDSText {
    __typename
    ...EGDSPlainTextFragment
    ...EGDSStandardLinkFragment
  }
  ${EGDSPlainText.fragment}
  ${EGDSStandardLink.fragment}
`;
var LoyaltyEGDSText = ({
  data,
  standardLinkProps,
  plainTextProps
}) => {
  const {
    __typename
  } = data;
  switch (__typename) {
    case "EGDSStandardLink":
      return /* @__PURE__ */React46.createElement(EGDSStandardLink, __spreadValues({
        data
      }, standardLinkProps));
    case "EGDSPlainText":
      return /* @__PURE__ */React46.createElement(EGDSPlainText, __spreadValues({
        data
      }, plainTextProps));
    default:
      return null;
  }
};
LoyaltyEGDSText.fragment = fragment18;
LoyaltyEGDSText.displayName = "LoyaltyEGDSText";

// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-section.tsx
import React48 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";

// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-description.tsx
import React47 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
var fragment19 = gql25`
  fragment LoyaltyAnchoredCurrencyDescriptionFragment on LoyaltyAnchoredCurrencyDescription {
    balance {
      ...EGDSStylizedTextFragment
    }
    subtitle {
      ...EGDSStylizedTextFragment
    }
  }
  ${EGDSStylizedText.fragment}
`;
var LoyaltyAnchoredCurrencyDescription = ({
  data
}) => {
  const {
    balance,
    subtitle
  } = data;
  return /* @__PURE__ */React47.createElement(EGDSLayoutFlex7, {
    alignItems: "center",
    direction: "column"
  }, /* @__PURE__ */React47.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React47.createElement(EGDSStylizedText, {
    data: balance
  })), /* @__PURE__ */React47.createElement(EGDSLayoutFlexItem6, {
    maxWidth: "37x"
  }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(EGDSStylizedText, {
    align: "center",
    data: subtitle
  }))));
};
LoyaltyAnchoredCurrencyDescription.fragment = fragment19;
LoyaltyAnchoredCurrencyDescription.displayName = "LoyaltyAnchoredCurrencyDescription";

// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-section.tsx
var fragment20 = gql26`
  fragment LoyaltyAnchoredCurrencySectionFragment on LoyaltyAnchoredCurrencySection {
    anchoredBalance {
      ...LoyaltyAnchoredCurrencyDescriptionFragment
    }
    posaBalance {
      ...LoyaltyAnchoredCurrencyDescriptionFragment
    }
    transferIcon {
      ...EGDSIconFragment
    }
  }
  ${LoyaltyAnchoredCurrencyDescription.fragment}
  ${LoyaltyEGDSIcon.fragment}
`;
var LoyaltyAnchoredCurrencySection = ({
  data
}) => {
  const {
    anchoredBalance,
    posaBalance,
    transferIcon
  } = data;
  return /* @__PURE__ */React48.createElement(EGDSLayoutFlex8, {
    space: "two",
    justifyContent: "center"
  }, /* @__PURE__ */React48.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React48.createElement(LoyaltyAnchoredCurrencyDescription, {
    data: posaBalance
  })), /* @__PURE__ */React48.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React48.createElement(LoyaltyEGDSIcon, {
    data: transferIcon
  })), /* @__PURE__ */React48.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React48.createElement(LoyaltyAnchoredCurrencyDescription, {
    data: anchoredBalance
  })));
};
LoyaltyAnchoredCurrencySection.fragment = fragment20;
LoyaltyAnchoredCurrencySection.displayName = "LoyaltyAnchoredCurrencySection";

// ../internal/src/components/loyalty-standard-link/loyalty-standard-link.tsx
import React49 from "react";
import { gql as gql27 } from "@apollo/client";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var fragment21 = gql27`
  fragment LoyaltyStandardLinkFragment on LoyaltyStandardLink {
    analytics {
      eventName
      eventVersion
      payload
    }
    link {
      ...EGDSStandardLinkFragment
    }
  }
  ${EGDSStandardLink.fragment}
`;
var LoyaltyStandardLink = ({
  data,
  align
}) => {
  const {
    analytics,
    link
  } = data;
  const clickstreamAnalytics = {
    eventName: analytics == null ? void 0 : analytics.eventName,
    eventVersion: analytics == null ? void 0 : analytics.eventVersion,
    serverPayload: analytics == null ? void 0 : analytics.payload
  };
  const track = useEgClickstream2();
  const handleClick = React49.useCallback(() => {
    if ((clickstreamAnalytics == null ? void 0 : clickstreamAnalytics.serverPayload) && (clickstreamAnalytics == null ? void 0 : clickstreamAnalytics.eventName) && (clickstreamAnalytics == null ? void 0 : clickstreamAnalytics.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: clickstreamAnalytics.eventName,
            event_version: clickstreamAnalytics.eventVersion
          }
        },
        serverPayload: clickstreamAnalytics.serverPayload
      });
    }
  }, [track, clickstreamAnalytics]);
  return /* @__PURE__ */React49.createElement(EGDSStandardLink, {
    data: link,
    onClickHandler: handleClick,
    align
  });
};
LoyaltyStandardLink.fragment = fragment21;
LoyaltyStandardLink.displayName = "LoyaltyStandardLink";

// ../internal/src/components/loyalty-universal-popup-dialog/loyalty-universal-popup-section-content-types.tsx
var fragment22 = gql28`
  fragment LoyaltyUniversalPopUpSectionContentTypesFragment on LoyaltyUniversalPopUpSectionContent {
    ...EGDSStylizedTextFragment
    ...LoyaltyAnchoredCurrencySectionFragment
    ...LoyaltyStandardLinkFragment
  }
  ${EGDSStylizedText.fragment}
  ${LoyaltyAnchoredCurrencySection.fragment}
  ${LoyaltyStandardLink.fragment}
`;
var LoyaltyUniversalPopUpSectionContentTypes = ({
  data,
  stylizedTextProps,
  loyaltyStandardLinkProps
}) => {
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React50.createElement(EGDSStylizedText, __spreadValues({
        data
      }, stylizedTextProps));
    case "LoyaltyAnchoredCurrencySection":
      return /* @__PURE__ */React50.createElement(LoyaltyAnchoredCurrencySection, {
        data
      });
    case "LoyaltyStandardLink":
      return /* @__PURE__ */React50.createElement(LoyaltyStandardLink, __spreadValues({
        data
      }, loyaltyStandardLinkProps));
    default:
      return null;
  }
};
LoyaltyUniversalPopUpSectionContentTypes.fragment = fragment22;
LoyaltyUniversalPopUpSectionContentTypes.displayName = "LoyaltyUniversalPopUpSectionContentTypes";

// ../internal/src/components/loyalty-universal-popup-dialog/loyalty-universal-popup-dialog-section.tsx
var fragment23 = gql29`
  fragment LoyaltyUniversalPopUpDialogSectionFragment on LoyaltyUniversalPopUpDialogSection {
    content {
      ...LoyaltyUniversalPopUpSectionContentTypesFragment
    }
    header
    alignment
  }
  ${LoyaltyUniversalPopUpSectionContentTypes.fragment}
`;
var textAlignmentMapper = {
  ["CENTER" /* CENTER */]: "center",
  ["LEFT" /* LEFT */]: "left",
  ["RIGHT" /* RIGHT */]: "right"
};
var LoyaltyUniversalPopUpDialogSection = ({
  data
}) => {
  const {
    content,
    header,
    alignment
  } = data;
  const textAlignment = alignment ? textAlignmentMapper[alignment] : "left";
  return /* @__PURE__ */React51.createElement(EGDSLayoutFlex9, {
    space: "two",
    direction: "column"
  }, /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React51.createElement(EGDSHeading2, {
    tag: "h2",
    size: 5,
    align: textAlignment
  }, header)), content.map((item, index) => /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem8, {
    key: `${item.__typename}_${index}`
  }, /* @__PURE__ */React51.createElement("div", null, /* @__PURE__ */React51.createElement(LoyaltyUniversalPopUpSectionContentTypes, {
    data: item,
    stylizedTextProps: {
      align: textAlignment
    },
    loyaltyStandardLinkProps: {
      align: textAlignment
    }
  })))));
};
LoyaltyUniversalPopUpDialogSection.fragment = fragment23;
LoyaltyUniversalPopUpDialogSection.displayName = "LoyaltyUniversalPopUpDialogSection";

// ../internal/src/components/loyalty-universal-popup-dialog/loyalty-universal-popup-dialog.tsx
var fragment24 = gql30`
  fragment LoyaltyUniversalPopUpDialogFragment on LoyaltyUniversalPopUpDialog {
    dismissButton {
      ...LoyaltyUniversalPopUpButtonFragment
    }
    sections {
      ...LoyaltyUniversalPopUpDialogSectionFragment
    }
    ariaLabel
    type
    toolbar {
      actions {
        primary {
          accessibility
        }
      }
    }
    impressionAnalytics {
      eventName
      eventVersion
      payload
    }
  }
  ${LoyaltyUniversalPopUpButton.fragment}
  ${LoyaltyUniversalPopUpDialogSection.fragment}
`;
var typeMapper = {
  ["CENTERED" /* CENTERED */]: "centered",
  ["FULLSCREEN" /* FULLSCREEN */]: "full"
};
var getSheetType = type => {
  if (!type) {
    return "centered";
  }
  const sheetType = typeMapper[type];
  return sheetType || "centered";
};
var LoyaltyUniversalPopUpDialog = ({
  handleClose,
  triggerRef,
  isVisible,
  data,
  analytics
}) => {
  const {
    sections,
    dismissButton,
    impressionAnalytics,
    toolbar,
    type,
    ariaLabel
  } = data;
  const track = useEgClickstream3();
  useEffect4(() => {
    if ((impressionAnalytics == null ? void 0 : impressionAnalytics.payload) && (impressionAnalytics == null ? void 0 : impressionAnalytics.eventName) && (impressionAnalytics == null ? void 0 : impressionAnalytics.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: impressionAnalytics.eventName,
            event_version: impressionAnalytics.eventVersion
          }
        },
        serverPayload: impressionAnalytics.payload
      });
    } else if (analytics) {
      track(analytics);
    }
  }, []);
  const padding = __spreadValues({
    inline: "six"
  }, toolbar ? {
    blockend: "six"
  } : {
    block: "six"
  });
  return /* @__PURE__ */React52.createElement(EGDSSheet2, {
    triggerRef,
    isVisible,
    type: getSheetType(type),
    returnFocusOnClose: true,
    centeredSheetSize: "small",
    ariaLabel: ariaLabel != null ? ariaLabel : void 0
  }, toolbar && /* @__PURE__ */React52.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: handleClose,
      navIconLabel: toolbar.actions.primary.accessibility || ""
    }
  }), /* @__PURE__ */React52.createElement(EGDSSheetContent2, {
    padded: false
  }, /* @__PURE__ */React52.createElement(EGDSSpacing11, {
    padding: __spreadValues({}, padding)
  }, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement(EGDSLayoutFlex10, {
    space: "four",
    direction: "column"
  }, sections.map((section, index) => /* @__PURE__ */React52.createElement(EGDSLayoutFlexItem9, {
    key: index
  }, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement(LoyaltyUniversalPopUpDialogSection, {
    data: section
  })))), dismissButton && /* @__PURE__ */React52.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement(LoyaltyUniversalPopUpButton, {
    onClickHandler: handleClose,
    data: dismissButton,
    isFullWidth: true
  }))))))));
};
LoyaltyUniversalPopUpDialog.fragment = fragment24;
LoyaltyUniversalPopUpDialog.displayName = "LoyaltyUniversalPopUpDialog";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/info-section.tsx
var fragment25 = gql31`
  fragment InfoSectionFragment on OneKeyUniversalOnboardingInfoSection {
    infoButton {
      ...OnboardingButtonFragment
    }
    infoDialog {
      ...LoyaltyUniversalPopUpDialogFragment
    }
  }

  ${OnboardingButton.fragment}
  ${LoyaltyUniversalPopUpDialog.fragment}
`;
var InfoSection = ({
  data
}) => {
  const {
    infoButton,
    infoDialog
  } = data;
  const infoButtonRef = useRef(null);
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog2("one-key-onboarding-info-section-dialog", "infoPwaDialog", true);
  const handleInfoButtonClick = useCallback7(() => {
    dialogActions.openDialog();
  }, [dialogActions]);
  const handleDialogActionClick = useCallback7(() => {
    dialogActions.closeDialog();
  }, [dialogActions]);
  const analyticsData = {
    event: {
      event_version: "1.0.0",
      event_name: "onekey_context_onboarding_onekey_cash.presented",
      event_type: "Impression"
    },
    experience: {
      page_name: "OKOnboarding",
      page_name_detailed: "OKOnboardingContextualScreen"
    }
  };
  return /* @__PURE__ */React53.createElement(React53.Fragment, null, /* @__PURE__ */React53.createElement(OnboardingButton, {
    domRef: infoButtonRef,
    data: infoButton,
    size: EGDSButtonSize3.SMALL,
    isNoTextAllowed: true,
    isFullWidth: true,
    onNullActionClick: handleInfoButtonClick
  }), /* @__PURE__ */React53.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React53.createElement(DialogComponent, null, /* @__PURE__ */React53.createElement(LoyaltyUniversalPopUpDialog, {
    data: infoDialog,
    handleClose: handleDialogActionClick,
    triggerRef: infoButtonRef,
    isVisible: isDialogOpen,
    analytics: analyticsData
  }))));
};
InfoSection.fragment = fragment25;
InfoSection.displayName = "InfoSection";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/title.tsx
import React54 from "react";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
import { useViewportMap as useViewportMap3, ViewSizes as ViewSizes3 } from "@shared-ui/viewport-context";
var headingSizeMap = {
  [ViewSizes3.SMALL]: 4,
  [ViewSizes3.MEDIUM]: 3
};
var Title2 = ({
  children
}) => {
  const headingSize = useViewportMap3(headingSizeMap);
  return /* @__PURE__ */React54.createElement(EGDSSpacing12, {
    margin: {
      blockend: "eight"
    }
  }, /* @__PURE__ */React54.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React54.createElement(EGDSHeading3, {
    tag: "h1",
    size: headingSize,
    align: "center"
  }, children)));
};
Title2.displayName = "Title";

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/toolbar.tsx
import React55, { useCallback as useCallback8 } from "react";
import { EGDSToolbar as EGDSToolbar2 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
var Toolbar = ({
  dismissButton
}) => {
  const {
    accessibility,
    analytics
  } = dismissButton.button;
  const clickTracker = useClickTracker5();
  const {
    closeDialog
  } = useOnboardingDialogContext();
  const {
    handleOnboardingButtonClick
  } = useOnboardingButton({
    button: dismissButton,
    onNullActionClick: closeDialog
  });
  const handleDismissButtonClick = useCallback8(() => {
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
    handleOnboardingButtonClick();
  }, [analytics, clickTracker, handleOnboardingButtonClick]);
  if (!accessibility) {
    return null;
  }
  return /* @__PURE__ */React55.createElement(EGDSToolbar2, {
    navigationContent: {
      navIconLabel: accessibility,
      onClick: handleDismissButtonClick
    },
    elevation: "flat"
  });
};

// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/contextual-screen.tsx
var fragment26 = gql32`
  fragment ContextualScreenFragment on OneKeyUniversalOnboardingContextualScreen {
    dismissButton {
      ...OnboardingButtonFragment
    }
    brandAssets {
      ...BrandAssetsFragment
    }
    oneKeyCashInfoSection {
      ...InfoSectionFragment
    }
    tierBadge {
      ...EGDSLoyaltyBadgeFragment
    }
    title
    benefits {
      ...BenefitFragment
    }
    balanceSection {
      ...BalanceSectionFragment
    }
    primaryButton {
      ...OnboardingButtonFragment
    }
    primaryLink {
      ...OnboardingLinkFragment
    }
    ariaLabel
  }

  ${OnboardingLink.fragment}
  ${EGDSLoyaltyBadge.fragment}
  ${BrandAssets.fragment}
  ${InfoSection.fragment}
  ${Benefit.fragment}
  ${BalanceSection.fragment}
  ${OnboardingButton.fragment}
`;
var ContextualScreen = ({
  data
}) => {
  const impressionClickstreamEventData = {
    event: {
      event_version: "1.0.0",
      event_name: "onekey_context_onboarding.viewed",
      event_type: "Page View"
    },
    experience: {
      page_name: "OKOnboarding",
      page_name_detailed: "OKOnboardingContextualScreen"
    }
  };
  const {
    brandAssets,
    dismissButton,
    oneKeyCashInfoSection,
    tierBadge,
    title,
    benefits,
    balanceSection,
    primaryButton,
    primaryLink,
    ariaLabel
  } = data;
  const systemEvents = useLoggerEvents2(UNIVERSAL_ONBOARDING_LOGGER_EVENTS);
  const {
    isDialogOpen
  } = useOnboardingDialogContext();
  const {
    proceedWithOnboardingFlow
  } = useOnboardingUtils();
  const handleOperationSuccess = useCallback9(() => {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_SUCCESS.log(stringifyEventPayload({
      message: "Contextual Screen mutation success"
    }));
  }, [systemEvents]);
  const handleOperationFailure = useCallback9(result => {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_FAILURE.log(stringifyEventPayload({
      message: `Contextual Screen mutation failure. Onboarding Operation response: ${JSON.stringify(result.data)}`
    }));
  }, [systemEvents]);
  const handleOperationError = useCallback9(error => {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_ERROR.log(stringifyEventPayload({
      message: "Contextual Screen mutation error",
      error
    }));
  }, [systemEvents]);
  return /* @__PURE__ */React56.createElement(EGDSSheet3, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "full",
    ariaLabel
  }, /* @__PURE__ */React56.createElement(EGDSSheetContent3, {
    padded: false
  }, /* @__PURE__ */React56.createElement(EgClickstreamImpressionTracker2, {
    eventData: impressionClickstreamEventData
  }, /* @__PURE__ */React56.createElement(EGDSLayoutGrid3, {
    rows: ["auto", MinMax2("0px", "1fr")],
    blockSize: "100vb"
  }, dismissButton && /* @__PURE__ */React56.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React56.createElement(Toolbar, {
    dismissButton
  })), /* @__PURE__ */React56.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React56.createElement(ContentSpacing2, null, /* @__PURE__ */React56.createElement(EGDSLayoutGrid3, {
    columns: [MinMax2("0px", "480px")],
    justifyContent: "center",
    alignItems: "center",
    "data-stid": "one-key-onboarding-contextual-screen"
  }, /* @__PURE__ */React56.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React56.createElement(BlockSpacing, null, /* @__PURE__ */React56.createElement("div", null, brandAssets && /* @__PURE__ */React56.createElement(BrandAssetsSpacing2, null, /* @__PURE__ */React56.createElement(BrandAssets, {
    data: brandAssets
  })), /* @__PURE__ */React56.createElement(Title2, null, title), /* @__PURE__ */React56.createElement(CardWithSpacing, null, /* @__PURE__ */React56.createElement(EGDSLayoutFlex11, {
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    space: "four"
  }, /* @__PURE__ */React56.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React56.createElement(EGDSLoyaltyBadge, {
    data: tierBadge
  })), benefits && /* @__PURE__ */React56.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React56.createElement(BenefitsSpacing, null, /* @__PURE__ */React56.createElement(Benefits, {
    benefits
  }))), balanceSection && /* @__PURE__ */React56.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React56.createElement(BalanceSection, {
    data: balanceSection
  })))), oneKeyCashInfoSection && /* @__PURE__ */React56.createElement(EGDSSpacing13, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React56.createElement("div", null, /* @__PURE__ */React56.createElement(InfoSection, {
    data: oneKeyCashInfoSection
  }))), /* @__PURE__ */React56.createElement(EGDSSpacing13, {
    margin: {
      blockstart: "eight"
    }
  }, /* @__PURE__ */React56.createElement("div", null, /* @__PURE__ */React56.createElement(OnboardingButton, {
    data: primaryButton,
    isFullWidth: true,
    size: EGDSButtonSize4.LARGE,
    dataStid: "one-key-onboarding-contextual-screen-primary-button",
    onOperationSuccess: handleOperationSuccess,
    onOperationFailure: handleOperationFailure,
    onOperationError: handleOperationError,
    onNullActionClick: proceedWithOnboardingFlow
  }))), primaryLink && /* @__PURE__ */React56.createElement(EGDSSpacing13, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React56.createElement("div", null, /* @__PURE__ */React56.createElement(OnboardingLink, {
    data: primaryLink,
    isButton: true,
    size: EGDSButtonSize4.LARGE,
    isFullWidth: true
  })))))))))))));
};
ContextualScreen.fragment = fragment26;
ContextualScreen.displayName = "ContextualScreen";

// src/components/one-key-onboarding/onboarding-screen.tsx
var OnboardingScreen = () => {
  const {
    currentScreen
  } = useOnboardingScreensContext();
  switch (currentScreen == null ? void 0 : currentScreen.__typename) {
    case "OneKeyUniversalOnboardingWelcomeScreen":
      {
        return /* @__PURE__ */React57.createElement(WelcomeScreen, {
          data: currentScreen
        });
      }
    case "OneKeyUniversalOnboardingContextualScreen":
      {
        return /* @__PURE__ */React57.createElement(ContextualScreen, {
          data: currentScreen
        });
      }
    default:
      {
        return null;
      }
  }
};
OnboardingScreen.displayName = "OnboardingScreen";

// src/components/one-key-onboarding/one-key-universal-onboarding/one-key-universal-onboarding.tsx
var __Query = gql33`
  query OneKeyUniversalOnboardingQuery($context: ContextInput!, $originUrl: String) {
    oneKeyUniversalOnboarding(context: $context, originUrl: $originUrl) {
      ...OneKeyUniversalOnboardingScreenFragment
    }
  }

  fragment OneKeyUniversalOnboardingScreenFragment on OneKeyUniversalOnboardingScreen {
    screen {
      ...OneKeyUniversalOnboardingScreenResultFragment
    }
  }

  fragment OneKeyUniversalOnboardingScreenResultFragment on OneKeyUniversalOnboardingScreenResult {
    ...WelcomeScreenFragment
    ...ContextualScreenFragment
  }

  ${WelcomeScreen.fragment}
  ${ContextualScreen.fragment}
`;
var OneKeyUniversalOnboarding = ({
  inputs,
  isRedirectionEnabled
}) => {
  const {
    isDialogOpen,
    openDialog,
    DialogComponent
  } = useOnboardingDialogContext();
  const [isDialogTriggered, setIsDialogTriggered] = useState4(false);
  const {
    context
  } = useBexApi3();
  const systemEvents = useLoggerEvents3(UNIVERSAL_ONBOARDING_LOGGER_EVENTS);
  const {
    setScreens
  } = useOnboardingScreensContext();
  const variables = __spreadProps(__spreadValues({}, inputs), {
    context
  });
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    variables,
    ssr: false
  });
  useEffect5(() => {
    if (data) {
      setScreens(data.oneKeyUniversalOnboarding);
    }
  }, [data]);
  useEffect5(() => {
    if ((data == null ? void 0 : data.oneKeyUniversalOnboarding) && data.oneKeyUniversalOnboarding.length > 0 && !isDialogTriggered) {
      openDialog();
      setIsDialogTriggered(true);
    }
  }, [data == null ? void 0 : data.oneKeyUniversalOnboarding, openDialog, isDialogTriggered]);
  useEffect5(() => {
    if ((data == null ? void 0 : data.oneKeyUniversalOnboarding.length) === 0 && isRedirectionEnabled) {
      navigateToRelativeUrlOrFallbackUrl(inputs.originUrl);
    }
  }, [data == null ? void 0 : data.oneKeyUniversalOnboarding, inputs.originUrl, isRedirectionEnabled]);
  useEffect5(() => {
    if (error) {
      systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_QUERY_ERROR.log(stringifyEventPayload({
        message: "OneKeyUniversalOnboardingQuery error",
        error
      }));
      if (isRedirectionEnabled) {
        navigateToErrorPage();
      }
    }
  }, [error, isRedirectionEnabled, systemEvents]);
  if (loading || error || !data) {
    return null;
  }
  if (data.oneKeyUniversalOnboarding.length === 0) {
    return null;
  }
  return /* @__PURE__ */React58.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React58.createElement(DialogComponent, null, /* @__PURE__ */React58.createElement(OnboardingScreen, null)));
};
OneKeyUniversalOnboarding.displayName = "OneKeyUniversalOnboarding";

// src/components/one-key-onboarding/one-key-onboarding-wrapper.tsx
var OneKeyOnboardingWrapper = ({
  additionalContext,
  isRedirectionEnabled = false
}) => {
  const {
    exposure: onboardingV2Exposure
  } = useExperiment("Onboarding_v2_Web");
  const {
    exposure: oneKeyOnboardingV2Exposure
  } = useExperiment("Onboarding_v2_OneKey_Web");
  const isOneIdentityOneKeyOnboardingV2Enabled = onboardingV2Exposure.bucket === 1;
  const isOneKeyOnboardingV2Enabled = oneKeyOnboardingV2Exposure.bucket === 1;
  const isV2FlowEnabled = isOneIdentityOneKeyOnboardingV2Enabled && isOneKeyOnboardingV2Enabled;
  const isOnboardingDisabled = !isV2FlowEnabled;
  useEffect6(() => {
    if (isOnboardingDisabled && isRedirectionEnabled) {
      navigateToRelativeUrlOrFallbackUrl(additionalContext == null ? void 0 : additionalContext.originUrl);
    }
  }, []);
  if (isOnboardingDisabled) {
    return null;
  }
  return /* @__PURE__ */React59.createElement(OnboardingDialogContextProvider, null, /* @__PURE__ */React59.createElement(OnboardingScreensProvider, null, /* @__PURE__ */React59.createElement(MutationProgressProvider, null, isV2FlowEnabled && /* @__PURE__ */React59.createElement(OneKeyUniversalOnboarding, {
    inputs: {
      originUrl: additionalContext == null ? void 0 : additionalContext.originUrl
    },
    isRedirectionEnabled
  }))));
};
OneKeyOnboardingWrapper.displayName = "sharedui-OneKeyOnboarding";
export { OneKeyOnboardingWrapper, toRelativeURL };
/* istanbul ignore next -- @preserve */